import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import Navbar from "../components/Navbar_menu";
import { apiUrl } from "../config/apiBase";
import AdminHypotekySadzby from "../components/admin/AdminHypotekySadzby";
import AdminHypotekyKampane from "../components/admin/AdminHypotekyKampane";
import AdminHypotekyParametre from "../components/admin/AdminHypotekyParametre";
import AdminSortHeading from "../components/admin/AdminSortHeading";
import {
  TYPY_PRISTUPU,
  UZIVATELSKE_OPRAVNENIA,
  maAdminPreProdukt,
  maAdminPreUzivatelov,
  normalizujPristup
} from "../auth/pristupyPouzivatelov";

import {
  normalizujAdminEmail,
  jeOdporucanaAdminEmailDomena,
  vytvorTextAdminEmailDomeny
} from "../utils/adminEmailPolicy";

import { stiahniAdminUsersCsv } from "../utils/adminUsersCsvExport";

import "../App.css";
import "../css/adminPouzivatelia.css";

const prazdnyFormular = {
  email: "",
  name: "",
  priezvisko: "",
  telefon: "",
  nbsCislo: "",
  role: "user",
  typPristupu: TYPY_PRISTUPU.UZIVATEL,
  adminPreUzivatelov: false,
  adminPreProdukt: false,
  uzivatelskeOpravnenia: {
    [UZIVATELSKE_OPRAVNENIA.VSETKO]: {
      aktivne: true,
      platneDo: ""
    },
    [UZIVATELSKE_OPRAVNENIA.UVERY]: {
      aktivne: false,
      platneDo: ""
    },
    [UZIVATELSKE_OPRAVNENIA.KT]: {
      aktivne: false,
      platneDo: ""
    },
    [UZIVATELSKE_OPRAVNENIA.POISTENIE]: {
      aktivne: false,
      platneDo: ""
    }
  }
};

function pristupNaFormular(pristup, user = {}) {
  const normalizovany =
    normalizujPristup(
      pristup,
      user
    );

  const uzivatelskeOpravnenia =
    Object.fromEntries(
      Object.entries(
        prazdnyFormular
          .uzivatelskeOpravnenia
      ).map(
        ([kod, hodnota]) => [
          kod,
          {
            ...hodnota
          }
        ]
      )
    );

  normalizovany
    .uzivatelskeOpravnenia
    .forEach((opravnenie) => {
      if (
        !uzivatelskeOpravnenia[
          opravnenie.kod
        ]
      ) {
        return;
      }

      uzivatelskeOpravnenia[
        opravnenie.kod
      ] = {
        aktivne:
          true,

        platneDo:
          opravnenie.platneDo
            ? String(
                opravnenie.platneDo
              ).slice(0, 10)
            : ""
      };
    });

  return {
    typPristupu:
      normalizovany.typ,

    adminPreUzivatelov:
      !!normalizovany
        .adminOpravnenia
        .adminPreUzivatelov,

    adminPreProdukt:
      !!normalizovany
        .adminOpravnenia
        .adminPreProdukt,

    uzivatelskeOpravnenia
  };
}

function formularNaPristup(formular) {
  return {
    typ:
      formular.typPristupu,

    adminOpravnenia: {
      adminPreUzivatelov:
        !!formular.adminPreUzivatelov,

      adminPreProdukt:
        !!formular.adminPreProdukt
    },

    uzivatelskeOpravnenia:
      Object
        .entries(
          formular
            .uzivatelskeOpravnenia ||
            {}
        )
        .filter(
          ([, hodnota]) =>
            hodnota?.aktivne
        )
        .map(
          ([kod, hodnota]) => ({
            kod,

            platneDo:
              hodnota?.platneDo ||
              null
          })
        )
  };
}

function nazovUzivatelskehoOpravnenia(kod) {
  const mapa = {
    [UZIVATELSKE_OPRAVNENIA.VSETKO]:
      "Všetky sektory",

    [UZIVATELSKE_OPRAVNENIA.UVERY]:
      "Úvery",

    [UZIVATELSKE_OPRAVNENIA.KT]:
      "KT",

    [UZIVATELSKE_OPRAVNENIA.POISTENIE]:
      "Poistenie"
  };

  return mapa[kod] || kod;
}

function jePlatnyEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
    String(email || "")
  );
}

function nazovImportStavu(
  stav
) {
  const mapa = {
    pripraveny:
      "Pripravený",

    upozornenie_domena:
      "Upozornenie – iná doména",

    chyba:
      "Chyba",

    duplicita_db:
      "Už existuje",

    duplicita_subor:
      "Duplicita v Exceli",

    vytvoreny:
      "Vytvorený",

    email_chyba:
      "Email sa neodoslal"
  };

  return (
    mapa[stav] ||
    stav ||
    ""
  );
}

export default function AdminPouzivatelia() {
  const nav =
    useNavigate();

  const {
    user: aktualnyUser,
    loading: authLoading
  } =
    useAuth();

  const [zoradenieUzivatelov, setZoradenieUzivatelov] = useState({ stlpec: "", smer: "asc" });
  const poziadavkaUzivatelov = useRef(0);
  useEffect(() => () => { poziadavkaUzivatelov.current += 1; }, []);
  const prepniZoradenieUzivatelov = (stlpec) => {
    poziadavkaUzivatelov.current += 1;
    setZoradenieUzivatelov((prev) => ({ stlpec, smer: prev.stlpec === stlpec && prev.smer === "asc" ? "desc" : "asc" }));
    setPage(1);
  };

  const [
    users,
    setUsers
  ] =
    useState([]);

  const [
    page,
    setPage
  ] =
    useState(1);

  const [
    totalPages,
    setTotalPages
  ] =
    useState(1);

  const [
    total,
    setTotal
  ] =
    useState(0);

  const [
    hladanie,
    setHladanie
  ] =
    useState("");

  const [
    hladanieServer,
    setHladanieServer
  ] =
    useState("");

  const [
    loading,
    setLoading
  ] =
    useState(false);

  const [
    message,
    setMessage
  ] =
    useState("");

  const [
    error,
    setError
  ] =
    useState("");

  const [
    modalOpen,
    setModalOpen
  ] =
    useState(false);

  const [
    editUser,
    setEditUser
  ] =
    useState(null);

  const [
    formular,
    setFormular
  ] =
    useState(
      prazdnyFormular
    );

  const [
    modalError,
    setModalError
  ] =
    useState("");

  const [
    modalSaving,
    setModalSaving
  ] =
    useState(false);

  const [
    deleteUser,
    setDeleteUser
  ] =
    useState(null);

  const [
    deleteError,
    setDeleteError
  ] =
    useState("");

  const [
    deleting,
    setDeleting
  ] =
    useState(false);

  const [
    importOpen,
    setImportOpen
  ] =
    useState(false);

  const [
    importSubor,
    setImportSubor
  ] =
    useState(null);

  const [
    importPreview,
    setImportPreview
  ] =
    useState(null);

  const [
    importVysledok,
    setImportVysledok
  ] =
    useState(null);

  const [
    importError,
    setImportError
  ] =
    useState("");

  const [
    importLoading,
    setImportLoading
  ] =
    useState(false);

  const [
    exportLoading,
    setExportLoading
  ] =
    useState(false);

  const [
    emailPolicy,
    setEmailPolicy
  ] =
    useState({
      odporucaneDomeny: []
    });

  const [
    aktivnaAdminSekcia,
    setAktivnaAdminSekcia
  ] =
    useState("pouzivatelia");

  const maPristupPouzivatelia =
    !authLoading &&
    maAdminPreUzivatelov(aktualnyUser);

  const maPristupProdukt =
    !authLoading &&
    maAdminPreProdukt(aktualnyUser);

  const predvolenaAdminSekcia =
    maPristupPouzivatelia
      ? "pouzivatelia"
      : maPristupProdukt
        ? "urokoveSadzby"
        : "";

  const zobrazenaAdminSekcia =
    (aktivnaAdminSekcia === "pouzivatelia" && maPristupPouzivatelia) ||
    (["urokoveSadzby", "kampane", "parametre"].includes(aktivnaAdminSekcia) && maPristupProdukt)
      ? aktivnaAdminSekcia
      : predvolenaAdminSekcia;

  /*
    Search debounce:
    nevoláme backend pri každom jednom stlačení klávesy.
  */
  useEffect(() => {
    const timeout =
      setTimeout(
        () => {
          setHladanieServer(
            hladanie.trim()
          );

          setPage(1);
        },
        300
      );

    return () =>
      clearTimeout(
        timeout
      );
  }, [hladanie]);

  const nacitajPouzivatelov =
    useCallback(
      async () => {
        const poziadavka = ++poziadavkaUzivatelov.current;
        setLoading(true);
        setError("");

        try {
          const params =
            new URLSearchParams({
                page:
                String(page)
            });
          if (zoradenieUzivatelov.stlpec) {
            params.set("sort", zoradenieUzivatelov.stlpec);
            params.set("direction", zoradenieUzivatelov.smer);
          }

          if (
            hladanieServer
          ) {
            params.set(
              "q",
              hladanieServer
            );
          }

          const r =
            await fetch(
              apiUrl(
                `/api/admin/users?${params.toString()}`
              ),
              {
                credentials:
                  "include"
              }
            );

          if (
            r.status === 401
          ) {
            nav(
              "/login",
              {
                replace: true
              }
            );

            return;
          }

          const data =
            await r
              .json()
              .catch(
                () => ({})
              );

          if (poziadavka !== poziadavkaUzivatelov.current) return;
          if (!r.ok) {
            throw new Error(
              data?.message ||
                "Používateľov sa nepodarilo načítať."
            );
          }

          setUsers(
            data.users ||
              []
          );

          setTotalPages(
            data.totalPages ||
              1
          );

          setTotal(
            data.total ||
              0
          );

          setEmailPolicy(
            data.emailPolicy || {
              odporucaneDomeny: []
            }
          );

        } catch (e) {
          if (poziadavka !== poziadavkaUzivatelov.current) return;
          setError(
            e.message ||
              "Používateľov sa nepodarilo načítať."
          );
        } finally {
          if (poziadavka === poziadavkaUzivatelov.current) setLoading(false);
        }
      },
      [
        page,
        hladanieServer,
        zoradenieUzivatelov,
        nav
      ]
    );

  useEffect(() => {
    if (authLoading) return;
    if (
      maAdminPreUzivatelov(
        aktualnyUser
      )
    ) {
      nacitajPouzivatelov();
    }
  }, [
    authLoading,
    aktualnyUser,
    nacitajPouzivatelov
  ]);

  useEffect(() => {
    if (
      aktivnaAdminSekcia ===
        "pouzivatelia" &&
      !maAdminPreUzivatelov(
        aktualnyUser
      ) &&
      maAdminPreProdukt(
        aktualnyUser
      )
    ) {
      setAktivnaAdminSekcia(
        "urokoveSadzby"
      );
    }
  }, [
    aktualnyUser,
    aktivnaAdminSekcia
  ]);

  const formularJeKompletny =
    useMemo(
      () =>
        Boolean(
          formular.email.trim() &&
          jePlatnyEmail(
            formular.email
          ) &&
          formular.name.trim() &&
          formular.priezvisko.trim() &&
          formular.telefon.trim() &&
          formular.nbsCislo.trim() &&
          (
            (
              formular.typPristupu ===
                TYPY_PRISTUPU.HLAVNY_ADMIN ||
              formular.typPristupu ===
                TYPY_PRISTUPU.CIASTOCNY_ADMIN ||
              formular.typPristupu ===
                TYPY_PRISTUPU.UZIVATEL
            ) &&
            (
              formular.typPristupu !==
                TYPY_PRISTUPU.CIASTOCNY_ADMIN ||
              (
                (
                  formular.adminPreUzivatelov ||
                  formular.adminPreProdukt
                ) &&
                formular.adminPreUzivatelov !==
                  formular.adminPreProdukt
              )
            ) &&
            (
              formular.typPristupu !==
                TYPY_PRISTUPU.UZIVATEL ||
              Object
                .values(
                  formular
                    .uzivatelskeOpravnenia ||
                    {}
                )
                .some(
                  (opravnenie) =>
                    opravnenie.aktivne
                )
            )
          )
        ),
      [formular]
    );

  const emailSaMeni =
    useMemo(
      () => {
        if (!editUser) {
          return true;
        }

        return (
          normalizujAdminEmail(
            formular.email
          ) !==
          normalizujAdminEmail(
            editUser.email
          )
        );
      },
      [
        editUser,
        formular.email
      ]
    );

  const maUpozornenieEmailDomeny =
    useMemo(
      () => {
        if (
          !formular.email.trim() ||
          !jePlatnyEmail(
            formular.email
          )
        ) {
          return false;
        }

        if (
          editUser &&
          !emailSaMeni
        ) {
          return false;
        }

        return !jeOdporucanaAdminEmailDomena(
          formular.email,
          emailPolicy
            .odporucaneDomeny
        );
      },
      [
        editUser,
        emailSaMeni,
        formular.email,
        emailPolicy
      ]
    );

  const emailDomenaUpozornenie =
    useMemo(
      () =>
        maUpozornenieEmailDomeny
          ? vytvorTextAdminEmailDomeny(
              emailPolicy
                .odporucaneDomeny
            )
          : "",
      [
        maUpozornenieEmailDomeny,
        emailPolicy
      ]
    );

  const importMaUpozornenia =
    Number(
      importPreview
        ?.statistika
        ?.upozornenia ||
        0
    ) > 0;

  const otvorPridanie =
    () => {
      setEditUser(null);

      setFormular({
        ...prazdnyFormular
      });

      setModalError("");
      setMessage("");
      setError("");
      setModalOpen(true);
    };

  const otvorUpravu =
    (u) => {
      setEditUser(
        u
      );

      setFormular({
        email:
          u.email || "",

        name:
          u.name || "",

        priezvisko:
          u.priezvisko ||
          "",

        telefon:
          u.telefon || "",

        nbsCislo:
          u.nbsCislo ||
          "",

        role:
          u.roles?.includes(
            "admin"
          )
            ? "admin"
            : u.roles?.includes(
                "partial_admin"
              )
              ? "partial_admin"
              : "user",

        ...pristupNaFormular(
          u.pristup,
          u
        )
      });

      setModalError("");
      setMessage("");
      setError("");
      setModalOpen(true);
    };

  const nastavPole =
    (
      nazov,
      hodnota
    ) => {
      setFormular(
        (prev) => ({
          ...prev,

          [nazov]:
            hodnota
        })
      );

      setModalError("");
    };

  const nastavTypPristupu =
    (typPristupu) => {
      setFormular(
        (prev) => ({
          ...prev,

          typPristupu,

          adminPreUzivatelov:
            typPristupu ===
              TYPY_PRISTUPU.CIASTOCNY_ADMIN,

          adminPreProdukt:
            false
        })
      );

      setModalError("");
    };

  const nastavAdminOpravnenie =
    (opravnenie, aktivne) => {
      setFormular(
        (prev) => ({
          ...prev,

          adminPreUzivatelov:
            opravnenie ===
              "adminPreUzivatelov"
              ? aktivne
              : aktivne
                ? false
                : prev.adminPreUzivatelov,

          adminPreProdukt:
            opravnenie ===
              "adminPreProdukt"
              ? aktivne
              : aktivne
                ? false
                : prev.adminPreProdukt
        })
      );

      setModalError("");
    };

  const ulozPouzivatela =
    async () => {
      if (
        !formularJeKompletny ||
        modalSaving
      ) {
        return;
      }

      setModalError("");
      setModalSaving(true);

      try {
        const jeEdit =
          Boolean(
            editUser?.id
          );

        const r =
          await fetch(
            apiUrl(
              jeEdit
                ? `/api/admin/users/${editUser.id}`
                : "/api/admin/users"
            ),
            {
              method:
                jeEdit
                  ? "PATCH"
                  : "POST",

              headers: {
                "Content-Type":
                  "application/json"
              },

              credentials:
                "include",

              body:
                JSON.stringify({
                  ...formular,

                  role:
                    formular.typPristupu ===
                      TYPY_PRISTUPU.HLAVNY_ADMIN
                      ? "admin"
                      : formular.typPristupu ===
                          TYPY_PRISTUPU.CIASTOCNY_ADMIN
                        ? "partial_admin"
                        : "user",

                  pristup:
                    formularNaPristup(
                      formular
                    ),

                  potvrditInuEmailDomenu:
                    maUpozornenieEmailDomeny
                })
            }
          );

        const data =
          await r
            .json()
            .catch(
              () => ({})
            );

        if (!r.ok) {
          throw new Error(
            data?.message ||
              "Používateľa sa nepodarilo uložiť."
          );
        }

        setModalOpen(
          false
        );

        setMessage(
          data?.message ||
            "Používateľ bol uložený."
        );

        if (
          data
            ?.vyzadujeNovePrihlasenie
        ) {
          nav(
            "/login",
            {
              replace: true
            }
          );

          return;
        }

        await nacitajPouzivatelov();

      } catch (e) {
        setModalError(
          e.message ||
            "Používateľa sa nepodarilo uložiť."
        );
      } finally {
        setModalSaving(
          false
        );
      }
    };

  const odosliOnboarding =
    async () => {
      if (
        !editUser?.id ||
        modalSaving
      ) {
        return;
      }

      setModalError("");
      setModalSaving(true);

      try {
        const r =
          await fetch(
            apiUrl(
              `/api/admin/users/${editUser.id}/onboarding-email`
            ),
            {
              method:
                "POST",

              credentials:
                "include"
            }
          );

        const data =
          await r
            .json()
            .catch(
              () => ({})
            );

        if (!r.ok) {
          throw new Error(
            data?.message ||
              "Onboarding email sa nepodarilo spracovať."
          );
        }

        setModalOpen(
          false
        );

        setMessage(
          data?.message ||
            "Onboarding email bol spracovaný."
        );

        await nacitajPouzivatelov();

      } catch (e) {
        setModalError(
          e.message ||
            "Onboarding email sa nepodarilo spracovať."
        );
      } finally {
        setModalSaving(
          false
        );
      }
    };

  const potvrditVymazanie =
    async () => {
      if (
        !deleteUser?.id ||
        deleting
      ) {
        return;
      }

      setDeleteError("");
      setDeleting(true);

      try {
        const r =
          await fetch(
            apiUrl(
              `/api/admin/users/${deleteUser.id}`
            ),
            {
              method:
                "DELETE",

              credentials:
                "include"
            }
          );

        const data =
          await r
            .json()
            .catch(
              () => ({})
            );

        if (!r.ok) {
          throw new Error(
            data?.message ||
              "Používateľa sa nepodarilo odstrániť."
          );
        }

        setDeleteUser(
          null
        );

        setMessage(
          data?.message ||
            "Používateľ bol odstránený."
        );

        if (
          users.length === 1 &&
          page > 1
        ) {
          setPage(
            (prev) =>
              Math.max(
                1,
                prev - 1
              )
          );
        } else {
          await nacitajPouzivatelov();
        }

      } catch (e) {
        setDeleteError(
          e.message ||
            "Používateľa sa nepodarilo odstrániť."
        );
      } finally {
        setDeleting(
          false
        );
      }
    };

  const exportujCsv =
    async () => {
      if (
        exportLoading
      ) {
        return;
      }

      setError("");
      setExportLoading(
        true
      );

      try {
        await stiahniAdminUsersCsv();

      } catch (e) {
        setError(
          e.message ||
            "CSV export sa nepodarilo vytvoriť."
        );

      } finally {
        setExportLoading(
          false
        );
      }
    };

  const otvorImport =
    () => {
      setImportSubor(
        null
      );

      setImportPreview(
        null
      );

      setImportVysledok(
        null
      );

      setImportError(
        ""
      );

      setImportOpen(
        true
      );
    };

  const nacitajPreview =
    async () => {
      if (
        !importSubor ||
        importLoading
      ) {
        return;
      }

      setImportError("");
      setImportPreview(null);
      setImportVysledok(null);
      setImportLoading(true);

      try {
        const formData =
          new FormData();

        formData.append(
          "subor",
          importSubor
        );

        const r =
          await fetch(
            apiUrl(
              "/api/admin/users/import-preview"
            ),
            {
              method:
                "POST",

              credentials:
                "include",

              body:
                formData
            }
          );

        const data =
          await r
            .json()
            .catch(
              () => ({})
            );

        if (!r.ok) {
          throw new Error(
            data?.message ||
              "Excel sa nepodarilo skontrolovať."
          );
        }

        setImportPreview(
          data
        );

      if (data.emailPolicy) {
        setEmailPolicy(
          data.emailPolicy
        );
      }

      } catch (e) {
        setImportError(
          e.message ||
            "Excel sa nepodarilo skontrolovať."
        );
      } finally {
        setImportLoading(
          false
        );
      }
    };

  const spustiImport =
    async () => {
      if (
        !importSubor ||
        !importPreview ||
        !importPreview
          ?.statistika
          ?.pripravene ||
        importLoading
      ) {
        return;
      }

      setImportError("");
      setImportVysledok(null);
      setImportLoading(true);

      try {
        const formData =
          new FormData();

        formData.append(
          "subor",
          importSubor
        );

        formData.append(
          "potvrditInuEmailDomenu",
          String(
            importMaUpozornenia
          )
        );

        const r =
          await fetch(
            apiUrl(
              "/api/admin/users/import"
            ),
            {
              method:
                "POST",

              credentials:
                "include",

              body:
                formData
            }
          );

        const data =
          await r
            .json()
            .catch(
              () => ({})
            );

        if (!r.ok) {
          throw new Error(
            data?.message ||
              "Import sa nepodarilo dokončiť."
          );
        }

        setImportPreview(
          null
        );

        setImportVysledok(
          data
        );

        await nacitajPouzivatelov();

      } catch (e) {
        setImportError(
          e.message ||
            "Import sa nepodarilo dokončiť."
        );
      } finally {
        setImportLoading(
          false
        );
      }
    };

  return (
    <>
      <Navbar />

      <div className="App">

        <div className="card-section admin-users-card admin-shell-card">
          <div className="admin-section-tabs">
            {maAdminPreUzivatelov(aktualnyUser) && (
              <button
                type="button"
                className={`applicant-tab ${zobrazenaAdminSekcia === "pouzivatelia" ? "is-active" : ""}`}
                onClick={() => setAktivnaAdminSekcia("pouzivatelia")}
              >
                Používatelia
              </button>
            )}

            {maAdminPreProdukt(aktualnyUser) && (
              <button
                type="button"
                className={`applicant-tab ${zobrazenaAdminSekcia === "urokoveSadzby" ? "is-active" : ""}`}
                onClick={() => setAktivnaAdminSekcia("urokoveSadzby")}
              >
                Úrokové sadzby
              </button>
            )}

            {maAdminPreProdukt(aktualnyUser) && (
              <button
                type="button"
                className={`applicant-tab ${zobrazenaAdminSekcia === "kampane" ? "is-active" : ""}`}
                onClick={() => setAktivnaAdminSekcia("kampane")}
              >
                Kampane
              </button>
            )}

            {maAdminPreProdukt(aktualnyUser) && (
              <button
                type="button"
                className={`applicant-tab ${zobrazenaAdminSekcia === "parametre" ? "is-active" : ""}`}
                onClick={() => setAktivnaAdminSekcia("parametre")}
              >
                Parametre
              </button>
            )}
          </div>
        </div>

        {zobrazenaAdminSekcia === "pouzivatelia" && maPristupPouzivatelia && (
          <div className="card-section admin-users-card">

          <div className="admin-users-header">

            <div>
              <h2>
                Správa používateľov
              </h2>

              <div className="form_hint">
                Celkom používateľov: {total}
              </div>
            </div>

            <div className="admin-users-header-actions">

              <button
                type="button"
                className="action-btn"
                disabled={
                  exportLoading
                }
                onClick={
                  exportujCsv
                }
              >
                {exportLoading
                  ? "Exportujem..."
                  : "Export CSV"}
              </button>

              <button
                type="button"
                className="action-btn"
                onClick={otvorImport}
              >
                Importovať Excel
              </button>

              <button
                type="button"
                className="action-btn"
                onClick={otvorPridanie}
              >
                + Pridať používateľa
              </button>

            </div>

          </div>

          <div className="admin-users-toolbar">

            <input
              className="form_input admin-users-search"
              type="search"
              value={hladanie}
              placeholder="Meno, priezvisko, email, telefón alebo NBS..."
              onChange={
                (e) =>
                  setHladanie(
                    e.target.value
                  )
              }
            />

          </div>

          {error && (
            <div className="admin-users-message admin-users-message--error">
              {error}
            </div>
          )}

          {message && (
            <div className="admin-users-message">
              {message}
            </div>
          )}

          <div className="admin-users-table-wrap">

            <table className="admin-users-table">

              <thead>
                <tr>
                  <AdminSortHeading stlpec="meno" zoradenie={zoradenieUzivatelov} onSort={prepniZoradenieUzivatelov}>Meno</AdminSortHeading>
                  <AdminSortHeading stlpec="priezvisko" zoradenie={zoradenieUzivatelov} onSort={prepniZoradenieUzivatelov}>Priezvisko</AdminSortHeading>
                  <AdminSortHeading stlpec="email" zoradenie={zoradenieUzivatelov} onSort={prepniZoradenieUzivatelov}>Email</AdminSortHeading>
                  <th>Telefón</th>
                  <th>NBS</th>
                  <AdminSortHeading stlpec="rola" zoradenie={zoradenieUzivatelov} onSort={prepniZoradenieUzivatelov}>Rola</AdminSortHeading>
                  <AdminSortHeading stlpec="stav" zoradenie={zoradenieUzivatelov} onSort={prepniZoradenieUzivatelov}>Stav</AdminSortHeading>
                  <th>Akcie</th>
                </tr>
              </thead>

              <tbody>

                {!loading &&
                  users.map(
                    (u) => (
                      <tr key={u.id}>

                        <td data-label="Meno">
                          {u.name}
                        </td>

                        <td data-label="Priezvisko">
                          {u.priezvisko}
                        </td>

                        <td data-label="Email">
                          {u.email}
                        </td>

                        <td data-label="Telefón">
                          {u.telefon}
                        </td>

                        <td data-label="NBS">
                          {u.nbsCislo}
                        </td>

                        <td data-label="Rola">
                          {u.rolaNazov}
                        </td>

                        <td data-label="Stav">

                          <span
                            className={
                              u.stav ===
                              "aktivny"
                                ? "admin-status admin-status--active"
                                : "admin-status admin-status--onboarding"
                            }
                          >
                            {u.stav ===
                            "aktivny"
                              ? "Aktívny"
                              : "Onboarding"}
                          </span>

                        </td>

                        <td data-label="Akcie">

                          <div className="admin-users-row-actions">

                            <button
                              type="button"
                              className="action-btn"
                              onClick={
                                () =>
                                  otvorUpravu(
                                    u
                                  )
                              }
                            >
                              Upraviť
                            </button>

                            <button
                              type="button"
                              className="action-btn admin-danger-btn"
                              onClick={
                                () => {
                                  setDeleteError(
                                    ""
                                  );

                                  setDeleteUser(
                                    u
                                  );
                                }
                              }
                            >
                              Vymazať
                            </button>

                          </div>

                        </td>

                      </tr>
                    )
                  )}

              </tbody>

            </table>

            {loading && (
              <div className="admin-users-empty">
                Načítavam používateľov...
              </div>
            )}

            {!loading &&
              !users.length && (
                <div className="admin-users-empty">
                  Nenašli sa žiadni používatelia.
                </div>
              )}

          </div>

          <div className="admin-pagination">

            <button
              type="button"
              className="action-btn"
              disabled={
                page <= 1
              }
              onClick={
                () =>
                  setPage(
                    (prev) =>
                      Math.max(
                        1,
                        prev - 1
                      )
                  )
              }
            >
              Predchádzajúca
            </button>

            <span>
              Strana {page} z {totalPages}
            </span>

            <button
              type="button"
              className="action-btn"
              disabled={
                page >=
                totalPages
              }
              onClick={
                () =>
                  setPage(
                    (prev) =>
                      Math.min(
                        totalPages,
                        prev + 1
                      )
                  )
              }
            >
              Ďalšia
            </button>

          </div>

          </div>
        )}

        {zobrazenaAdminSekcia === "urokoveSadzby" && maPristupProdukt && (
          <AdminHypotekySadzby />
        )}

        {zobrazenaAdminSekcia === "kampane" && maPristupProdukt && (
          <AdminHypotekyKampane />
        )}
        {zobrazenaAdminSekcia === "parametre" && maPristupProdukt && (
          <AdminHypotekyParametre />
        )}

      </div>

      {modalOpen && (
        <div
          className="pdf-modal-overlay"
          onClick={
            () => {
              if (
                !modalSaving
              ) {
                setModalOpen(
                  false
                );
              }
            }
          }
        >
          <div
            className="pdf-modal admin-user-modal"
            role="dialog"
            aria-modal="true"
            onClick={
              (e) =>
                e.stopPropagation()
            }
          >

            <div className="pdf-modal__header">

              <h2 className="pdf-modal__title">
                {editUser
                  ? "Upraviť používateľa"
                  : "Pridať používateľa"}
              </h2>

            </div>

            <div className="pdf-modal__body">

              <div className="admin-modal-grid">

                <div className="pdf-modal__field">
                  <label className="pdf-modal__label">
                    Email
                  </label>

                  <input
                    className="pdf-modal__input"
                    type="email"
                    value={formular.email}
                    onChange={
                      (e) =>
                        nastavPole(
                          "email",
                          e.target.value
                        )
                    }
                  />
                </div>

                <div className="pdf-modal__field">
                  <label className="pdf-modal__label">
                    Meno
                  </label>

                  <input
                    className="pdf-modal__input"
                    type="text"
                    value={formular.name}
                    onChange={
                      (e) =>
                        nastavPole(
                          "name",
                          e.target.value
                        )
                    }
                  />
                </div>

                <div className="pdf-modal__field">
                  <label className="pdf-modal__label">
                    Priezvisko
                  </label>

                  <input
                    className="pdf-modal__input"
                    type="text"
                    value={formular.priezvisko}
                    onChange={
                      (e) =>
                        nastavPole(
                          "priezvisko",
                          e.target.value
                        )
                    }
                  />
                </div>

                <div className="pdf-modal__field">
                  <label className="pdf-modal__label">
                    Telefón
                  </label>

                  <input
                    className="pdf-modal__input"
                    type="text"
                    value={formular.telefon}
                    onChange={
                      (e) =>
                        nastavPole(
                          "telefon",
                          e.target.value
                        )
                    }
                  />
                </div>

                <div className="pdf-modal__field">
                  <label className="pdf-modal__label">
                    NBS číslo
                  </label>

                  <input
                    className="pdf-modal__input"
                    type="text"
                    value={formular.nbsCislo}
                    onChange={
                      (e) =>
                        nastavPole(
                          "nbsCislo",
                          e.target.value
                        )
                    }
                  />
                </div>

                <div className="pdf-modal__field">

                  <label className="pdf-modal__label">
                    Rola
                  </label>

                  <select
                    className="pdf-modal__input"
                    value={formular.typPristupu}
                    onChange={
                      (e) =>
                        nastavTypPristupu(
                          e.target.value
                        )
                    }
                  >
                    <option value={TYPY_PRISTUPU.UZIVATEL}>
                      Užívateľ
                    </option>

                    <option value={TYPY_PRISTUPU.CIASTOCNY_ADMIN}>
                      Čiastočný admin
                    </option>

                    {normalizujPristup(
                      aktualnyUser?.pristup,
                      aktualnyUser
                    ).typ === TYPY_PRISTUPU.HLAVNY_ADMIN && (
                      <option value={TYPY_PRISTUPU.HLAVNY_ADMIN}>
                        Hlavný admin
                      </option>
                    )}
                  </select>

                </div>



                {formular.typPristupu === TYPY_PRISTUPU.CIASTOCNY_ADMIN && (
                  <div className="pdf-modal__field admin-access-field">
                    <label className="pdf-modal__label">
                      Admin oprávnenia
                    </label>

                    <label className="admin-access-option">
                      <input
                        type="checkbox"
                        checked={formular.adminPreUzivatelov}
                        onChange={(e) =>
                          nastavAdminOpravnenie(
                            "adminPreUzivatelov",
                            e.target.checked
                          )
                        }
                      />
                      <span>Admin pre používateľov</span>
                    </label>

                    <label className="admin-access-option">
                      <input
                        type="checkbox"
                        checked={formular.adminPreProdukt}
                        onChange={(e) =>
                          nastavAdminOpravnenie(
                            "adminPreProdukt",
                            e.target.checked
                          )
                        }
                      />
                      <span>Admin pre produkt</span>
                    </label>
                  </div>
                )}

                {formular.typPristupu === TYPY_PRISTUPU.UZIVATEL && (
                  <div className="pdf-modal__field admin-access-field admin-access-field--wide admin-sectors-preview">
                    <label className="pdf-modal__label">
                      Užívateľské oprávnenia - sektory:
                    </label>

                    {Object.entries(formular.uzivatelskeOpravnenia).map(([kod, hodnota]) => (
                      <div className="admin-access-row" key={kod}>
                        <label className="admin-access-option">
                          <input
                            type="checkbox"
                            disabled
                            checked={hodnota.aktivne}
                            onChange={(e) =>
                              nastavPole("uzivatelskeOpravnenia", {
                                ...formular.uzivatelskeOpravnenia,
                                [kod]: {
                                  ...hodnota,
                                  aktivne: e.target.checked
                                }
                              })
                            }
                          />
                          <span>{nazovUzivatelskehoOpravnenia(kod)}</span>
                        </label>

                        <input
                          className="pdf-modal__input admin-access-date"
                          type="date"
                          value={hodnota.platneDo}
                          disabled
                          onChange={(e) =>
                            nastavPole("uzivatelskeOpravnenia", {
                              ...formular.uzivatelskeOpravnenia,
                              [kod]: {
                                ...hodnota,
                                platneDo: e.target.value
                              }
                            })
                          }
                        />
                      </div>
                    ))}
                    {["Vklady", "DDS", "SDS"].map((nazov) => (
                      <div className="admin-access-row" key={nazov}>
                        <label className="admin-access-option">
                          <input type="checkbox" checked={false} disabled />
                          <span>{nazov}</span>
                        </label>
                        <input
                          className="pdf-modal__input admin-access-date"
                          type="date"
                          aria-label={`${nazov} - platné do`}
                          value=""
                          disabled
                        />
                      </div>
                    ))}
                  </div>
                )}

              </div>

              {modalError && (
                <div className="admin-modal-error">
                  {modalError}
                </div>
              )}

            </div>

            <div className="pdf-modal__footer admin-modal-footer">

              {maUpozornenieEmailDomeny && (
                <span className="admin-email-domain-warning">
                  {emailDomenaUpozornenie}
                </span>
              )}

              {editUser
                ?.onboarding
                ?.vyzadujePrveHeslo && (
                  <button
                    type="button"
                    className="action-btn"
                    disabled={
                      modalSaving
                    }
                    onClick={
                      odosliOnboarding
                    }
                  >
                    Odoslať nový onboarding email
                  </button>
              )}

              <button
                type="button"
                className="action-btn"
                disabled={
                  modalSaving
                }
                onClick={
                  () =>
                    setModalOpen(
                      false
                    )
                }
              >
                Zrušiť
              </button>

              <button
                type="button"
                className="action-btn"
                disabled={
                  !formularJeKompletny ||
                  modalSaving
                }
                onClick={
                  ulozPouzivatela
                }
              >
                {modalSaving
                  ? "Ukladám..."
                  : maUpozornenieEmailDomeny
                    ? "Napriek tomu uložiť"
                    : "Uložiť"}
              </button>

            </div>

          </div>
        </div>
      )}

      {deleteUser && (
        <div
          className="pdf-modal-overlay"
          onClick={
            () => {
              if (
                !deleting
              ) {
                setDeleteUser(
                  null
                );
              }
            }
          }
        >
          <div
            className="pdf-modal"
            role="dialog"
            aria-modal="true"
            onClick={
              (e) =>
                e.stopPropagation()
            }
          >

            <div className="pdf-modal__header">

              <h2 className="pdf-modal__title">
                Vymazať používateľa
              </h2>

            </div>

            <div className="pdf-modal__body">

              <p>
                Naozaj chcete natrvalo vymazať používateľa{" "}

                <strong>
                  {deleteUser.name}{" "}
                  {deleteUser.priezvisko}
                </strong>

                {" "}
                ({deleteUser.email})?
              </p>

              {deleteError && (
                <div className="admin-modal-error">
                  {deleteError}
                </div>
              )}

            </div>

            <div className="pdf-modal__footer">

              <button
                type="button"
                className="action-btn"
                disabled={
                  deleting
                }
                onClick={
                  () =>
                    setDeleteUser(
                      null
                    )
                }
              >
                Zrušiť
              </button>

              <button
                type="button"
                className="action-btn admin-danger-btn"
                disabled={
                  deleting
                }
                onClick={
                  potvrditVymazanie
                }
              >
                {deleting
                  ? "Mažem..."
                  : "Vymazať"}
              </button>

            </div>

          </div>
        </div>
      )}

      {importOpen && (
        <div
          className="pdf-modal-overlay"
          onClick={
            () => {
              if (
                !importLoading
              ) {
                setImportOpen(
                  false
                );
              }
            }
          }
        >
          <div
            className="pdf-modal admin-import-modal"
            role="dialog"
            aria-modal="true"
            onClick={
              (e) =>
                e.stopPropagation()
            }
          >

            <div className="pdf-modal__header">

              <h2 className="pdf-modal__title">
                {importVysledok
                  ? "Výsledok importu používateľov"
                  : "Import používateľov z Excelu"}
              </h2>

            </div>

            <div className="pdf-modal__body">

            {!importVysledok && (
              <div className="pdf-modal__field">

                <label className="pdf-modal__label">
                  Excel súbor (.xlsx)
                </label>

                <input
                  className="pdf-modal__input admin-import-file"
                  type="file"
                  accept=".xlsx"
                  disabled={
                    importLoading
                  }
                  onChange={
                    (e) => {
                      setImportSubor(
                        e.target.files?.[0] ||
                          null
                      );

                      setImportPreview(
                        null
                      );

                      setImportVysledok(
                        null
                      );

                      setImportError(
                        ""
                      );
                    }
                  }
                />

              </div>
            )}

              {importError && (
                <div className="admin-modal-error">
                  {importError}
                </div>
              )}

              {importPreview && !importVysledok && (
                <>
                  <div className="admin-import-summary">

                    <span>
                      Spolu:{" "}
                      <strong>
                        {importPreview.statistika?.spolu}
                      </strong>
                    </span>

                    <span>
                      Pripravené:{" "}
                      <strong>
                        {importPreview.statistika?.pripravene}
                      </strong>
                    </span>

                    <span>
                      Upozornenia:{" "}
                      <strong>
                        {importPreview.statistika?.upozornenia || 0}
                      </strong>
                    </span>

                    <span>
                      Chyby:{" "}
                      <strong>
                        {importPreview.statistika?.chyby}
                      </strong>
                    </span>

                    <span>
                      Duplicity:{" "}
                      <strong>
                        {importPreview.statistika?.duplicity}
                      </strong>
                    </span>

                    </div>

                    {importMaUpozornenia && (
                      <div className="admin-import-domain-warning">
                        {importPreview.statistika?.upozornenia}{" "}
                        {importPreview.statistika?.upozornenia === 1
                          ? "používateľ má"
                          : "používatelia majú"}{" "}
                        inú ako odporúčanú emailovú doménu.
                        Skontrolujte označené riadky alebo import
                        vedome potvrďte.
                      </div>
                    )}

                    <div className="admin-import-table-wrap">

                    <table className="admin-users-table">

                      <thead>
                        <tr>
                          <th>Riadok</th>
                          <th>Email</th>
                          <th>Meno</th>
                          <th>Priezvisko</th>
                          <th>Telefón</th>
                          <th>NBS</th>
                          <th>Stav</th>
                        </tr>
                      </thead>

                      <tbody>

                        {importPreview
                          .riadky
                          ?.map(
                            (r) => (
                              <tr
                                key={
                                  r.riadok
                                }
                              >

                                <td data-label="Riadok">
                                  {r.riadok}
                                </td>

                                <td data-label="Email">
                                  {r.email}
                                </td>

                                <td data-label="Meno">
                                  {r.name}
                                </td>

                                <td data-label="Priezvisko">
                                  {r.priezvisko}
                                </td>

                                <td data-label="Telefón">
                                  {r.telefon}
                                </td>

                                <td data-label="NBS">
                                  {r.nbsCislo}
                                </td>

                                <td data-label="Stav">
                                  <span
                                    className={
                                      r.stav ===
                                        "upozornenie_domena"
                                        ? "admin-import-status-warning"
                                        : ""
                                    }
                                  >
                                    {nazovImportStavu(
                                      r.stav
                                    )}
                                  </span>
                                </td>

                              </tr>
                            )
                          )}

                      </tbody>

                    </table>

                  </div>
                </>
              )}

              {importVysledok && (
                <>
                  <div className="admin-import-summary">

                    <span>
                      Vytvorení:{" "}
                      <strong>
                        {importVysledok.statistika?.vytvoreni}
                      </strong>
                    </span>

                    <span>
                      Email chyba:{" "}
                      <strong>
                        {importVysledok.statistika?.emailChyba}
                      </strong>
                    </span>

                    <span>
                      Nevytvorení:{" "}
                      <strong>
                        {importVysledok.statistika?.nevytvoreni}
                      </strong>
                    </span>

                  </div>

                  <div className="admin-import-table-wrap">

                    <table className="admin-users-table">

                      <thead>
                        <tr>
                          <th>Riadok</th>
                          <th>Email</th>
                          <th>Stav</th>
                          <th>Výsledok</th>
                        </tr>
                      </thead>

                      <tbody>

                        {importVysledok
                          .vysledky
                          ?.map(
                            (r) => (
                              <tr
                                key={
                                  `${r.riadok}-${r.email}`
                                }
                              >

                                <td data-label="Riadok">
                                  {r.riadok}
                                </td>

                                <td data-label="Email">
                                  {r.email}
                                </td>

                                <td data-label="Stav">
                                  <span
                                    className={
                                      r.stav ===
                                        "upozornenie_domena"
                                        ? "admin-import-status-warning"
                                        : ""
                                    }
                                  >
                                    {nazovImportStavu(
                                      r.stav
                                    )}
                                  </span>
                                </td>

                                <td data-label="Výsledok">
                                  {r.message}
                                </td>

                              </tr>
                            )
                          )}

                      </tbody>

                    </table>

                  </div>
                </>
              )}

            </div>

            <div className="pdf-modal__footer">

            <button
              type="button"
                className="action-btn"
                disabled={
                  importLoading
                }
                onClick={
                  () =>
                    setImportOpen(
                      false
                    )
                }
              >
                Zavrieť
              </button>

          {!importVysledok && (
            <>
              <button
                type="button"
                className="action-btn"
                disabled={
                  !importSubor ||
                  importLoading
                }
                onClick={
                  nacitajPreview
                }
              >
                {importLoading
                  ? "Spracovávam..."
                  : "Skontrolovať"}
              </button>

              <button
                type="button"
                className="action-btn"
                disabled={
                  !importPreview ||
                  !importPreview
                    ?.statistika
                    ?.pripravene ||
                  importLoading
                }
                onClick={
                  spustiImport
                }
              >
                {importMaUpozornenia
                  ? "Napriek upozorneniam importovať"
                  : "Importovať"}
              </button>
            </>
          )}

            </div>

          </div>
        </div>
      )}

    </>
  );
}
